import WidgetPanel from "components/common/WidgetPanel";
import ProgressBar from "components/common/ProgressBar";
import { getCurrentProductSubscriptionDetail } from "shared/utility/ProductSubscriptionHelper";
import { RootState } from "store/store";
import { connect } from "react-redux";
import Subscription from "interfaces/response/Subscription";
import moment from "moment";
import { getFormattedNumber } from "shared/utility/NumberUtility";
import NextPaymentDetails from "interfaces/response/NextPaymentDetails";
import { getNextPaymentDetails } from "shared/utility/ProductSubscriptionHelper";
import ActionConsumptionProgressSubscriptionSummary from "./ActionConsumptionProgressSubscriptionSummary";
import { NextPaymentDetailsType } from "shared/enums/NextPaymentDetailsTypeEnum";

interface Props {
  currentSubscription?: Subscription | null;
  nextPaymentDetails?: NextPaymentDetails;
}

export function ActionConsumptionProgressWidget(props: Props) {
  const { currentSubscription, nextPaymentDetails } = props;

  const getActionStatus = () => {
    let isLimitReachead = false;
    let text = "";

    if (currentSubscription && currentSubscription.numberOfAllowedActions) {
      text = `${getFormattedNumber(
        currentSubscription.numberOfAllowedActions
      )} limit`;

      if (
        currentSubscription.consumptionSummary &&
        currentSubscription.consumptionSummary.consumedActions >=
          currentSubscription.numberOfAllowedActions
      ) {
        isLimitReachead = true;
        text = `${text} reached`;
      }
    }

    return (
      <span className={`${isLimitReachead ? "font-bold" : "text-promGray2"}`}>
        {text}
      </span>
    );
  };

  const ActionStatus = () => {
    return (
      <>
        <div className="hidden lg:inline-block float-right">
          {getActionStatus()}
        </div>
        <div className="inline-block lg:hidden mb-3">
          <div className="font-semibold text-lg">
            {getFormattedNumber(currentSubscription?.consumptionSummary?.consumedActions ?? 0)}{" "}
            actions
          </div>
          <div className="font-medium text-promGray2 text-sm">
            out of {getFormattedNumber(currentSubscription?.numberOfAllowedActions ?? 0)} daily limit
          </div>
        </div>
      </>
    );
  };

  return (
    <WidgetPanel
      title="Actions last 24hrs"
      hideHeaderOnSmallScreen
      headerMargin="mb-1"
    >
      <>
        <div className="mb-4">
          <ActionStatus />
          <div className="clear-both">
            <ProgressBar
              progress={
                currentSubscription?.consumptionSummary?.consumedActions
              }
              totalNumber={currentSubscription?.numberOfAllowedActions}
              progressCaption="actions used"
              remainingSpaceCaption="left today"
              progressColorClass={
                nextPaymentDetails?.type ===
                  NextPaymentDetailsType.GracePeriod ||
                nextPaymentDetails?.type === NextPaymentDetailsType.PaymentDue
                  ? "bg-promRed1"
                  : ""
              }
              isPaused={
                nextPaymentDetails && nextPaymentDetails.type === NextPaymentDetailsType.PaymentDue
              }
              pausedCaption="Subscription Paused"
            />
          </div>
        </div>
        <div className="flex flex-wrap mt-8 lg:mt-0 justify-between items-center gap-y-4">
          <div>
            <div className="text-sm">
              Limit resets:{" "}
              {nextPaymentDetails?.type ===
              NextPaymentDetailsType.PaymentDue ? (
                <span className="text-promGray2">
                  when payment issue is resolved
                </span>
              ) : (
                <span>
                  {moment(
                    currentSubscription?.consumptionSummary?.periodFinishTime
                  ).format("Do MMMM HH:mm Z")}
                </span>
              )}
            </div>
          </div>
          <div>
            <div className="float-right">
              <ActionConsumptionProgressSubscriptionSummary
                nextPaymentDetails={nextPaymentDetails}
              />
            </div>
          </div>
        </div>
      </>
    </WidgetPanel>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    currentSubscription: getCurrentProductSubscriptionDetail(state),
    nextPaymentDetails: getNextPaymentDetails(state),
  };
};

export default connect(mapStateToProps)(ActionConsumptionProgressWidget);
